import React, { useEffect, useMemo, useState } from "react";
import RecipeAuthor from "components/recipe-author";
import Link from "components/link";
import Pagination from "components/pagination";
import * as styles from "./styles.mod.scss";
import getImagePath from "helpers/get-image-path";

const RecipeCard = ({ recipes, section }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const afterPageChange = () => {
    document.getElementById("all-recipes")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {

    setCurrentPage(1);
  }, [recipes]);

  const recipesResult = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return recipes?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, recipes]);

  return (
    <div>
      <div className={`${styles.recipe} ${section && styles.sectionStyle}`}>
        {recipesResult?.map((data, i) => {
          return (
            <div key={i} className={styles.singleRecipe}>
              <Link to={`/recipe/${data?.handle}`}>
                <div className={styles.recipeImg}>
                  <img src={getImagePath(data?.image)} alt={data?.image?.alt} />
                </div>
                <h3 className={styles.title}>{data?.title}</h3>
              </Link>
              <RecipeAuthor author={data?.author} />
            </div>
          );
        })}
      </div>
      <Pagination
        currentPage={currentPage}
        totalCount={recipes?.length}
        pageSize={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
        afterPageChange={afterPageChange}
      />
    </div>
  );
};

export default RecipeCard;
